import { createImmerReducer } from 'common/reducerBase';
import gettyRecord, { getNewList, initialFilters } from '../../common/data/GettyRecord';
import { types } from '../actions';

const {
  SET_USER_LOGIN_SUCCESS,
  SET_USER_LOGOUT_SUCCESS,
  SET_SEARCH_PARAMS,
  CLEAR_SEARCH_TERM,
  CLEAR_RESULTS,
  SET_RESULTS_RETRIEVE_SUCCESS,
  SET_RESULTS_RETRIEVE_START,
  SET_RESULTS_RETRIEVE_END,
  TOGGLE_FILTERS_PANEL,
  CLEAR_FILTER_PARAMS,
  SELECT_ASSETS,
  SELECT_ASSETS_FORMAT,
  SELECT_PRODUCT,
  RETRIEVE_PRODUCTS_SUCCESS,
  PURCHASE_START,
  PURCHASE_END,
  PURCHASE_SUCCESS,
  SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS,
  RETRIEVE_DOWNLOADS_SUCCESS,
  RETRIEVE_ACCOUNT_INFO_SUCCESS,
  RETRIEVE_ASSET_DETAILS_SUCCESS,
} = types;

export default {
  getty: createImmerReducer(gettyRecord(), {
    [SET_USER_LOGIN_SUCCESS]: (draft, { payload }) => {
      draft.isSignedIn = true;
    },
    [SET_USER_LOGOUT_SUCCESS]: (draft) => {
      const initialState = gettyRecord();
      return initialState;
    },
    [SET_SEARCH_PARAMS]: (draft, { payload }) => {
      payload &&
        Object.keys(payload).forEach((item) => {
          if (item === 'filters') {
            Object.keys(payload[item]).forEach((filter) => {
              draft.filters[filter] = payload[item][filter];
            });
          } else {
            draft[item] = payload[item];
          }
        });

      if (payload?.filters) {
        draft.areFiltersSet = true;
      }
    },
    [CLEAR_SEARCH_TERM]: (draft, { payload }) => {
      draft.searchPhrase = '';
      draft.list = {
        ...getNewList(),
      };
    },
    [CLEAR_RESULTS]: (draft, { payload }) => {
      draft.list = {
        ...getNewList(),
        assetsInProgress: draft.list.assetsInProgress,
      };
    },
    [SET_RESULTS_RETRIEVE_SUCCESS]: (draft, { payload }) => {
      if (payload) {
        draft.list.items.push(...payload.items);
        draft.list.page = payload.page;
        draft.list.total = payload.total;
        draft.list.hasMoreAssets = payload.total > draft.list.items.length;
      }
    },
    [SET_HOME_PAGE_RESULTS_RETRIEVE_SUCCESS]: (draft, { payload }) => {
      if (payload) {
        draft.homePageItems = [...payload.items];
      }
    },
    [SET_RESULTS_RETRIEVE_START]: (draft, { payload }) => {
      draft.list.assetsInProgress = true;
    },
    [SET_RESULTS_RETRIEVE_END]: (draft, { payload }) => {
      draft.list.assetsInProgress = false;
    },
    [TOGGLE_FILTERS_PANEL]: (draft) => {
      draft.isFiltersPanelOpen = !draft.isFiltersPanelOpen;
    },
    [CLEAR_FILTER_PARAMS]: (draft) => {
      draft.filters = initialFilters();
      draft.areFiltersSet = false;
    },
    [SELECT_ASSETS]: (draft, { payload }) => {
      draft.list.selected = draft.list.selected === payload.items ? undefined : payload.items;
      draft.selectedFormat = undefined;
      draft.selectedProduct = undefined;
      draft.purchasedUrl = undefined;
    },
    [SELECT_PRODUCT]: (draft, { payload }) => {
      draft.selectedProduct = draft.products.find((item) => item.id === payload);
      draft.selectedFormat = undefined;
    },
    [SELECT_ASSETS_FORMAT]: (draft, { payload }) => {
      draft.selectedFormat = payload;
      draft.purchasedUrl = undefined;
    },
    [RETRIEVE_PRODUCTS_SUCCESS]: (draft, { payload }) => {
      draft.products = payload;
    },
    [RETRIEVE_DOWNLOADS_SUCCESS]: (draft, { payload }) => {
      draft.downloads = payload;
      draft.shouldDownloadsBeRefreshed = false;
    },
    [PURCHASE_START]: (draft) => {
      draft.purchaseInProgress = true;
    },
    [PURCHASE_END]: (draft) => {
      draft.purchaseInProgress = false;
    },
    [PURCHASE_SUCCESS]: (draft, { payload }) => {
      draft.purchasedUrl = payload.uri;
      draft.shouldDownloadsBeRefreshed = true;
    },
    [RETRIEVE_ACCOUNT_INFO_SUCCESS]: (draft, { payload }) => {
      draft.account = payload;
    },
    [RETRIEVE_ASSET_DETAILS_SUCCESS]: (draft, { payload }) => {
      const itemsIndex = draft.list.items.findIndex((item) => item.id === payload.id);
      const homeItemsIndex = draft.homePageItems.findIndex((item) => item.id === payload.id);

      if (itemsIndex > -1) {
        draft.list.items[itemsIndex] = { ...draft.list.items[itemsIndex], ...payload };
      }
      if (homeItemsIndex > -1) {
        draft.homePageItems[homeItemsIndex] = { ...draft.homePageItems[homeItemsIndex], ...payload };
      }
    },
  }),
};
